import { createFileRoute, redirect } from "@tanstack/react-router";

import { SettingsContentLayout } from "../components/settings/SettingsShell";
import { orgUrlSegment } from "../orgRouting";
import { readLastPickedOrgId } from "../state/orgs";

/**
 * The legacy org-less settings tree. Settings are tenant-scoped like the
 * rest of the app (`/$org/settings/$section`), so sessions with a known
 * organization are redirected there; this tree keeps serving environments
 * with no tenant directory (plain T3 dev, org-less sessions) — and old
 * bookmarks.
 */
export const Route = createFileRoute("/settings")({
  beforeLoad: async ({ context, location }) => {
    if (
      context.authGateState.status !== "authenticated" &&
      context.authGateState.status !== "hosted-static"
    ) {
      throw redirect({ to: "/pair", replace: true });
    }

    const lastPickedOrgId = readLastPickedOrgId();
    if (lastPickedOrgId) {
      const section = location.pathname.slice("/settings/".length) || "general";
      throw redirect({
        to: "/$org/settings/$section",
        params: { org: orgUrlSegment(lastPickedOrgId), section },
        hash: location.hash,
        replace: true,
      });
    }

    if (location.pathname === "/settings") {
      throw redirect({ to: "/settings/general", replace: true });
    }
  },
  component: SettingsContentLayout,
});
